import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20cleaning%20team%20in%20modern%20bright%20office%20space%20with%20cleaning%20equipment%2C%20natural%20light%20streaming%20through%20large%20windows%2C%20fresh%20and%20clean%20aesthetic%2C%20minimal%20and%20elegant%20composition%2C%20soft%20neutral%20tones%20with%20touches%20of%20green%2C%20editorial%20photography%20style%2C%20crisp%20details%2C%20harmonious%20and%20inviting%20atmosphere%2C%20shallow%20depth%20of%20field%20on%20a%20clean%20modern%20interior&width=1600&height=900&seq=limpia-hero-01&orientation=landscape"
          alt={t('hero.titleLine1') + ' ' + t('hero.titleLine2')}
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 text-background-50 text-xs font-medium mb-6">
            <i className="ri-sparkling-line"></i>
            {t('hero.badge')}
          </div>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
            {t('hero.titleLine1')}<br />
            <span className="text-primary-300">{t('hero.titleLine2')}</span>
          </h1>
          <p className="text-base md:text-lg text-background-50/80 max-w-xl mx-auto mb-8 leading-relaxed">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold transition-all hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              {t('hero.ctaQuote')}
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 text-sm font-semibold transition-all hover:bg-background-50/20 whitespace-nowrap cursor-pointer"
            >
              {t('hero.ctaServices')}
              <i className="ri-arrow-down-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a
          href="#services"
          className="flex flex-col items-center gap-2 text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
        >
          <span className="text-xs font-medium">{t('hero.scroll')}</span>
          <div className="w-5 h-8 rounded-full border-2 border-background-50/30 flex items-start justify-center p-1">
            <div className="w-1.5 h-1.5 rounded-full bg-background-50 animate-bounce"></div>
          </div>
        </a>
      </div>
    </section>
  );
}